import React, { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import './assets/styles/App.scss';
import Home from './pages/Home/Home';
import LoadingProvider from './context/loadingContext/LoadingProvider';
import { hasCookieConsent } from './utils/cookieUtils';
import { QueryProvider } from './providers/QueryProvider';
import CookieBanner from './components/common/Modals/Cookie/CookieBanner';
import { AppRoutes } from './routes/routes';
import MatomoWrapper from './components/features/MatomoWrapper/MatomoWrapper';
import CacheSessionModal from './components/features/SessionExpiration/CacheSessionModal';
import RehydrationLoader from './components/features/SessionExpiration/RehydrationLoader';

function App() {
  const [showCookieBanner, setShowCookieBanner] = useState<boolean>(false);

  useEffect(() => {
    if (!hasCookieConsent()) {
      const timeoutId = setTimeout(() => {
        setShowCookieBanner(true);
      }, 3000);

      return () => clearTimeout(timeoutId); // Clear the theme timeout on unmount
    }
  }, []);

  const handleConsent = () => {
    setShowCookieBanner(false);
  };

  const handleReject = () => {
    setShowCookieBanner(false);
  };

  return (
    <QueryProvider>
      <LoadingProvider>
        <BrowserRouter>
          <MatomoWrapper>
            <RehydrationLoader>
              <CacheSessionModal>
                <Home>
                  <AppRoutes />
                </Home>
              </CacheSessionModal>
            </RehydrationLoader>
          </MatomoWrapper>
        </BrowserRouter>
        {showCookieBanner && (
          <CookieBanner onConsent={handleConsent} onReject={handleReject} />
        )}
      </LoadingProvider>
    </QueryProvider>
  );
}

export default App;
